function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import { selectInstrument } from '../actions/instrumentActions';
import { recalculateOrderFormValues, isOrderEntryFormChanged } from '../../helpers/recalculateOrderHelper';
import { getOrdersBySide } from '../../helpers/orderHelper';

/**
 * Responsible for recalculate order fee and total amount when order entry form values are changed (default and advanced)
 */
var placeOrderMiddleware = function placeOrderMiddleware(store) {
  return function (next) {
    return function (action) {
      var _store$getState = store.getState(),
        form = _store$getState.form,
        level2 = _store$getState.apexCore.level2;
      var advancedOrderEntryFormIsInitialized = !!form.advancedOrderEntry;
      var reportBlockTradeFromIsInitialized = !!form.reportBlockTrade;
      if (isOrderEntryFormChanged(action)) {
        if (action.meta.field === 'instrument') {
          store.dispatch(selectInstrument(parseInt(action.payload, 10)));
          return next(action);
        }
        var orderEntryForm = form.orderEntry;
        if (advancedOrderEntryFormIsInitialized) {
          orderEntryForm = form.advancedOrderEntry;
        } else if (reportBlockTradeFromIsInitialized) {
          orderEntryForm = form.reportBlockTrade;
        }
        var updatedForm = Object.assign({}, orderEntryForm.values, _defineProperty({}, action.meta.field, action.payload));
        recalculateOrderFormValues(store, {
          form: updatedForm,
          formName: action.meta.form,
          orders: getOrdersBySide(updatedForm.side, level2)
        });
        return next(action);
      }
      return next(action);
    };
  };
};
export default placeOrderMiddleware;